import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import {
  Box, Button, Paper, Stack, TextField, Typography, Grid,
  FormControlLabel, Checkbox,
} from "@mui/material";
import Swal from "sweetalert2";
import { obterUsuario, salvarUsuario } from "../../services/usuarioService";
import { isAdmin } from "../../services/authService";

export default function UsuarioForm() {
  const { id } = useParams();
  const navigate = useNavigate();
  const admin = isAdmin();
  const [u, setU] = useState({ Codigo: 0, Nome: "", Email: "", Login: "", Ativo: true, Api: false, Admin: false, Financeiro: false, Senha: "" });

  useEffect(() => {
    if (!id) return;
    (async () => {
      const { data } = await obterUsuario(id);
      setU({ ...data, Senha: "" });
    })();
  }, [id]);

  const salvar = async () => {
    if (!u.Nome.trim() || !u.Login.trim())
      return Swal.fire("Atenção", "Nome e login são obrigatórios.", "warning");
    try {
      const { data } = await salvarUsuario(u);
      await Swal.fire("Sucesso", data.mensagem, "success");
      navigate("/usuarios");
    } catch (e) {
      Swal.fire("Erro", e?.response?.data || e.message, "error");
    }
  };

  return (
    <Box>
      <Stack direction="row" justifyContent="space-between" mb={2}>
        <Typography variant="h5">{id ? `Usuário #${id}` : "Novo usuário"}</Typography>
        <Stack direction="row" spacing={1}>
          <Button onClick={() => navigate("/usuarios")}>Voltar</Button>
          <Button variant="contained" onClick={salvar}>Salvar</Button>
        </Stack>
      </Stack>

      <Paper sx={{ p: 2 }}>
        <Grid container spacing={2}>
          <Grid size={{ xs: 12, sm: 6 }}>
            <TextField fullWidth label="Nome" value={u.Nome}
              onChange={(e) => setU({ ...u, Nome: e.target.value })} />
          </Grid>
          <Grid size={{ xs: 12, sm: 6 }}>
            <TextField fullWidth label="E-mail" value={u.Email || ""}
              onChange={(e) => setU({ ...u, Email: e.target.value })} />
          </Grid>
          <Grid size={{ xs: 12, sm: 6 }}>
            <TextField fullWidth label="Login" value={u.Login}
              onChange={(e) => setU({ ...u, Login: e.target.value })} />
          </Grid>
          <Grid size={{ xs: 12, sm: 6 }}>
            <TextField fullWidth type="password" label={id ? "Nova senha (deixe vazio p/ manter)" : "Senha"}
              value={u.Senha} onChange={(e) => setU({ ...u, Senha: e.target.value })} />
          </Grid>
          <Grid size={{ xs: 12 }}>
            <FormControlLabel control={<Checkbox checked={!!u.Ativo}
              onChange={(e) => setU({ ...u, Ativo: e.target.checked })} />} label="Ativo" />
            <FormControlLabel control={<Checkbox checked={!!u.Api}
              onChange={(e) => setU({ ...u, Api: e.target.checked })} />} label="Acesso API" />
            <FormControlLabel control={<Checkbox checked={!!u.Admin} disabled={!admin}
              onChange={(e) => setU({ ...u, Admin: e.target.checked })} />} label="Administrador" />
            <FormControlLabel control={<Checkbox checked={!!u.Financeiro} disabled={!admin}
              onChange={(e) => setU({ ...u, Financeiro: e.target.checked })} />} label="Financeiro" />
          </Grid>
          {!admin && (
            <Grid size={{ xs: 12 }}>
              <Typography variant="caption" color="text.secondary">
                Somente administradores podem alterar os perfis Administrador e Financeiro.
              </Typography>
            </Grid>
          )}
        </Grid>
      </Paper>
    </Box>
  );
}
